
import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';

export default function ProjectDetailPage() {
  const { id } = useParams();
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [showLightbox, setShowLightbox] = useState(false);

  // Mock data - gerçek uygulamada API'den gelecek
  const project = {
    id: 1,
    title: 'Ataşehir Residence',
    location: 'Ataşehir, İstanbul',
    area: '15.000 m²',
    status: 'Devam Eden',
    statusColor: 'bg-blue-500',
    description: 'Modern yaşam konsepti ile tasarlanan Ataşehir Residence, şehrin merkezinde konumlanmış lüks bir konut projesidir. Çağdaş mimari anlayışı ile tasarlanan proje, sakinlerine konforlu ve kaliteli bir yaşam sunmaktadır.',
    startDate: '2023',
    endDate: '2025',
    contractor: 'Birsöz İnşaat',
    client: 'Ataşehir Belediyesi',
    progress: 65,
    images: [
      'https://public.readdy.ai/ai/img_res/2d49b96e7f17c3d476c12ceb914ffbf7.jpg',
      'https://readdy.ai/api/search-image?query=construction%20site%20interior%20view%20with%20concrete%20structure%20and%20steel%20framework%2C%20modern%20building%20under%20construction%2C%20architectural%20progress%20documentation%2C%20clean%20background&width=800&height=600&seq=14&orientation=landscape',
      'https://readdy.ai/api/search-image?query=architectural%20rendering%20of%20completed%20modern%20residential%20complex%2C%20contemporary%20apartment%20buildings%20with%20glass%20facades%2C%20urban%20housing%20development%20visualization%2C%20clean%20background&width=800&height=600&seq=15&orientation=landscape',
      'https://readdy.ai/api/search-image?query=construction%20workers%20and%20engineers%20on%20building%20site%2C%20safety%20helmets%20and%20construction%20equipment%2C%20professional%20construction%20team%20at%20work%2C%20clean%20background&width=800&height=600&seq=16&orientation=landscape'
    ],
    features: [
      'Akıllı ev sistemleri',
      'Enerji verimli tasarım',
      'Geniş yeşil alanlar',
      'Kapalı otopark',
      'Fitness merkezi',
      'Çocuk oyun alanları',
      'Güvenlik kamera sistemi',
      '24/7 güvenlik hizmeti'
    ],
    floorPlans: [
      { type: '2+1 Daire', area: '85 m²' },
      { type: '3+1 Daire', area: '120 m²' },
      { type: '4+1 Dubleks', area: '180 m²' }
    ]
  };

  const relatedProjects = [
    {
      id: 2,
      title: 'Kadıköy Plaza',
      location: 'Kadıköy, İstanbul',
      image: 'https://readdy.ai/api/search-image?query=completed%20modern%20commercial%20plaza%20building%20with%20glass%20facade%2C%20contemporary%20office%20architecture%2C%20urban%20commercial%20development%2C%20clean%20background%2C%20professional%20photography%20style&width=300&height=200&seq=17&orientation=landscape'
    },
    {
      id: 3,
      title: 'Beşiktaş Towers',
      location: 'Beşiktaş, İstanbul',
      image: 'https://readdy.ai/api/search-image?query=future%20modern%20twin%20towers%20architectural%20rendering%2C%20contemporary%20high-rise%20building%20design%2C%20urban%20skyline%20development%20project%2C%20clean%20background%2C%20professional%20architectural%20visualization&width=300&height=200&seq=18&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Breadcrumb */}
      <section className="pt-24 pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-[14px] text-gray-600">
            <Link to="/" className="hover:text-[#0e3851]">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/projeler" className="hover:text-[#0e3851]">Projeler</Link>
            <span className="mx-2">/</span>
            <span className="text-[#0e3851]">{project.title}</span>
          </nav>
        </div>
      </section>

      {/* Hero */}
      <section className="pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative">
            <img 
              src={project.images[activeImageIndex]}
              alt={project.title}
              className="w-full h-96 object-cover rounded-2xl cursor-pointer"
              onClick={() => setShowLightbox(true)}
            />
            <span className={`absolute top-4 right-4 px-4 py-2 rounded-full text-white text-[14px] font-medium ${project.statusColor}`}>
              {project.status}
            </span>
            <button 
              onClick={() => setShowLightbox(true)}
              className="absolute bottom-4 right-4 bg-black/50 text-white px-4 py-2 rounded-xl text-[14px] hover:bg-black/70 transition-colors"
            >
              <i className="ri-image-line mr-2"></i>
              Galeriyi Gör
            </button>
          </div>
          
          {/* Thumbnail Images */}
          <div className="flex gap-4 mt-4 overflow-x-auto">
            {project.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`${project.title} ${index + 1}`}
                className={`w-20 h-16 object-cover rounded-lg cursor-pointer flex-shrink-0 ${
                  activeImageIndex === index ? 'ring-2 ring-[#0e3851]' : ''
                }`}
                onClick={() => setActiveImageIndex(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Proje Detayları */}
      <section className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Sol Kolon - Açıklama ve Özellikler */}
            <div className="lg:col-span-2 space-y-8">
              <div>
                <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">{project.title}</h1>
                <div className="flex items-center text-[16px] text-gray-600 mb-6">
                  <i className="ri-map-pin-line mr-2"></i>
                  {project.location}
                </div>
                <p className="text-[15px] text-gray-600 leading-relaxed">
                  {project.description}
                </p>
              </div>

              <Card>
                <h3 className="text-[18px] font-semibold text-[#0e3851] mb-4">Teknik Özellikler</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {project.features.map((feature, index) => (
                    <div key={index} className="flex items-center text-[14px] text-gray-600">
                      <i className="ri-check-line text-[#0e3851] mr-2"></i>
                      {feature}
                    </div>
                  ))}
                </div>
              </Card>

              {project.status === 'Devam Eden' && (
                <Card>
                  <h3 className="text-[18px] font-semibold text-[#0e3851] mb-4">Proje İlerlemesi</h3>
                  <div className="mb-2 flex justify-between text-[14px]">
                    <span className="text-gray-600">Tamamlanma Oranı</span>
                    <span className="font-semibold text-[#0e3851]">{project.progress}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3">
                    <div 
                      className="bg-[#0e3851] h-3 rounded-full transition-all duration-500"
                      style={{ width: `${project.progress}%` }}
                    ></div>
                  </div>
                </Card>
              )}
            </div>

            {/* Sağ Kolon - Proje Bilgileri */}
            <div className="space-y-6">
              <Card>
                <h3 className="text-[18px] font-semibold text-[#0e3851] mb-4">Proje Bilgileri</h3>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-[14px] text-gray-600">Başlangıç:</span>
                    <span className="text-[14px] font-medium">{project.startDate}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-[14px] text-gray-600">Bitiş:</span>
                    <span className="text-[14px] font-medium">{project.endDate}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-[14px] text-gray-600">Yüklenici:</span>
                    <span className="text-[14px] font-medium">{project.contractor}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-[14px] text-gray-600">İşveren:</span>
                    <span className="text-[14px] font-medium">{project.client}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-[14px] text-gray-600">Alan:</span>
                    <span className="text-[14px] font-medium">{project.area}</span>
                  </div>
                </div>
              </Card>

              <Card>
                <h3 className="text-[18px] font-semibold text-[#0e3851] mb-4">Kat Planları</h3>
                <div className="space-y-3">
                  {project.floorPlans.map((plan, index) => (
                    <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0">
                      <span className="text-[14px] text-gray-600">{plan.type}</span>
                      <span className="text-[14px] font-medium">{plan.area}</span>
                    </div>
                  ))}
                </div>
                <Button size="sm" variant="outline" className="w-full mt-4">
                  <i className="ri-download-line mr-2"></i>
                  Planları İndir
                </Button>
              </Card>

              <Card>
                <h3 className="text-[18px] font-semibold text-[#0e3851] mb-4">İletişim</h3>
                <p className="text-[14px] text-gray-600 mb-4">
                  Bu proje hakkında detaylı bilgi almak için bizimle iletişime geçin.
                </p>
                <Button className="w-full">
                  <i className="ri-phone-line mr-2"></i>
                  Bilgi Al
                </Button>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* İlgili Projeler */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-[22px] font-semibold text-[#0e3851] mb-8 text-center">İlgili Projeler</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {relatedProjects.map((relatedProject) => (
              <Card key={relatedProject.id} hover>
                <img 
                  src={relatedProject.image}
                  alt={relatedProject.title}
                  className="w-full h-48 object-cover rounded-xl mb-4"
                />
                <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2">{relatedProject.title}</h3>
                <p className="text-[14px] text-gray-600 mb-4">{relatedProject.location}</p>
                <Link to={`/projeler/${relatedProject.id}`}>
                  <Button variant="outline" size="sm" className="w-full">
                    Detayları Gör
                  </Button>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {showLightbox && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl w-full">
            <button 
              onClick={() => setShowLightbox(false)}
              className="absolute top-4 right-4 text-white text-[24px] hover:text-gray-300 z-10"
            >
              <i className="ri-close-line"></i>
            </button>
            <img 
              src={project.images[activeImageIndex]}
              alt={project.title}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
            />
            <div className="flex justify-center mt-4 gap-2">
              {project.images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveImageIndex(index)}
                  className={`w-3 h-3 rounded-full ${
                    activeImageIndex === index ? 'bg-white' : 'bg-white/50'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
